import React from "react";

import { isDefined } from "@bps/common-utils";
import { Spinner } from "@bps/fluent-ui";
import { TerminologyLookupRequest } from "@libs/gateways/clinical/ClinicalGateway.dtos.ts";
import { ClinicalRecord } from "@stores/clinical/models/ClinicalRecord.ts";
import { User } from "@stores/core/models/User.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import {
  DataFetcher,
  DataFetcherProps
} from "@ui-components/data-fetcher/DataFetcher.tsx";

export const MedicalHistoryDataFetcher: React.FC<
  Pick<DataFetcherProps<User[]>, "children"> & {
    clinicalRecord: ClinicalRecord;
  }
> = props => {
  const { clinical, core } = useStores();
  const { clinicalRecord, children } = props;

  const dataSource =
    clinicalRecord.clinicalData?.medicalHistory?.medicalHistories ?? [];

  const fetchData = async () => {
    // NOTE: Get lookup a coded system on the ontoserver
    const terminologyLookupCodes: TerminologyLookupRequest[] = dataSource
      .filter(({ diagnosisCode }) => diagnosisCode?.codeSystem)
      .map(
        ({ diagnosisCode }) =>
          diagnosisCode && {
            code: diagnosisCode.code,
            codeSystem: diagnosisCode.codeSystem,
            version: diagnosisCode.version
          }
      )
      .filter(isDefined);

    const [users] = await Promise.all([
      core.fetchUsers({
        privateSecGroupIds: dataSource
          .filter(x => !!x.secGroupId)
          .map(x => x.secGroupId!)
      }),
      terminologyLookupCodes?.length > 0
        ? clinical.getTerminologiesLookup(terminologyLookupCodes)
        : undefined
    ]);

    return users;
  };

  return (
    <DataFetcher fetch={fetchData} fallback={<Spinner />}>
      {data => children(data)}
    </DataFetcher>
  );
};
